import styled from "@emotion/styled";

import SkeletonText from "components/ui/skeleton/SkeletonText";
import { CHART_HEIGHT } from "./BuyerSupplierChart";
import { ChartSkeleton } from "./ChartSkeleton";

/**
 * The relationship page's overview while it loads: title, controls, figures and chart, in the
 * shape they will take. One placeholder for the whole wait, so the page doesn't step through
 * a different loader for each piece.
 */
export function BuyerSupplierOverviewSkeleton() {
  return (
    <Overview role="status" aria-label="Loading relationship">
      <SkeletonText width="min(560px, 100%)" fontSize={24} lineHeight={1.33} shimmer />
      <Controls>
        <SkeletonText width="120px" height={32} variant="rectangular" customSpacing shimmer />
        <SkeletonText width="150px" height={32} variant="rectangular" customSpacing shimmer />
      </Controls>
      <Figures>
        {[0, 1].map((figure) => (
          <Figure key={figure}>
            <SkeletonText width="110px" shimmer />
            <SkeletonText width="96px" fontSize={24} lineHeight={1.33} shimmer />
            <SkeletonText width="200px" shimmer />
          </Figure>
        ))}
      </Figures>
      <ChartSkeleton height={CHART_HEIGHT} />
    </Overview>
  );
}

const Overview = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: 32,
});

const Controls = styled.div({
  display: "flex",
  gap: 8,
});

const Figures = styled.div({
  display: "flex",
  flexWrap: "wrap",
  columnGap: 48,
  rowGap: 16,
});

const Figure = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: 4,
});
